import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e63711aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-end mt-3" }
const _hoisted_2 = { class: "d-flex justify-content-center mt-5" }

import { reactive, ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import Vue3Signature from "vue3-signature";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignatureModal',
  emits: ["handelSignature"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(true);
const modalForm = ref<InstanceType<typeof SimpleForm>>();
const signatureRef = ref<InstanceType<typeof Vue3Signature>>();



const state = reactive({
  count: 0,
  option: {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(255,255,255)",
  },
  disabled: false,
});

const save = (t) => {
  emits("handelSignature", signatureRef.value?.save(t));
};

const clear = () => {
  signatureRef.value?.clear();
};

const undo = () => {
  signatureRef.value?.undo();
};

// const fromDataURL = (url) => {
//   signatureRef.value?.fromDataURL(
//     "https://avatars2.githubusercontent.com/u/17644818?s=460&v=4"
//   );
// };

__expose({
  async show() {
    modalForm.value?.show();
  },
  hide() {
    modalForm.value?.hide();
  },
  clear,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SimpleForm, {
      ref_key: "modalForm",
      ref: modalForm,
      title: _ctx.$t('title.signature'),
      "is-loading": isLoading.value,
      "disable-footer": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Vue3Signature), {
          ref_key: "signatureRef",
          ref: signatureRef,
          sigOption: state.option,
          w: '600px',
          h: '200px',
          disabled: state.disabled,
          class: "example",
          style: {"border":"1px solid #000"}
        }, null, 8, ["sigOption", "disabled"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn btn-light btn-warning btn-md me-3",
              onClick: clear
            }, _toDisplayString(_ctx.$t("action.clear")), 1),
            _createElementVNode("button", {
              class: "btn btn-light btn-success btn-md me-3",
              onClick: undo
            }, _toDisplayString(_ctx.$t("action.undo")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn btn-light btn-primary btn-lg me-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (save('image/jpeg')))
            }, _toDisplayString(_ctx.$t("action.save")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "is-loading"])
  ]))
}
}

})